module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevii",
      "title": "vii"
    }
  }, [_vm._v("Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angus and Neilian with Seryozha and Volodya in their Moscow apartment")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Volodya aged four with his mother and aunt and the President of the Soviet Union, Mikhail Kalinin")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garik and Inna Basyrov")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Couple’ by Garik Basyrov")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A crowd gathers to watch me performing on a ladder . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(". . . and how the piece to camera appeared in the report")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Filing a report by satellite telephone from Chechnya")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Russian troops pose in front of the destroyed presidential palace in Grozny")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My friend Nikolai Vorontsov with Boris Yeltsin in front of the Russian parliament during the 1991 coup")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My children, Ewan, Duncan and Katie, on the BBC car near Red Square")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig10a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ewan playing under Lenin’s watchful eye in 1989")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soviet soldiers raise the Red Flag above the Reichstag in Berlin at the end of the Second World War")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yevgeny Khaldei, the photographer of the Reichstag picture, reunited with the then 18-year-old soldier who raised the flag, Aleksey Kovalyov")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Consulting the shaman in Siberia")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On a plane with the man who might have been president, Boris Nemtsov")])]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/plates#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(". . . and meeting the man who did become president, Vladimir Putin, at a Valdai Club dinner")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c1f3aca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illu.vue
// module id = 72
// module chunks = 0